import React from 'react';
import PropTypes from 'prop-types';
import { AppState } from '../state/MyStateProvider';
import FirebaseRepository from './FirebaseRepository';

export const FirebaseState = React.createContext(null);

const MyFirebaseProvider = ({ children, firebaseConfig }) => {
  const { state, dispatch } = React.useContext(AppState);

  const [firebaseRepo] = React.useState(new FirebaseRepository(state, dispatch, firebaseConfig));

  React.useEffect(() => {
    const unsubscribe = firebaseRepo.firebaseApi.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // console.log(user);
        // User is signed in.
        firebaseRepo.saveUser(user);
      } else {
        // console.log('logged out');
        // User is signed out.
        firebaseRepo.logoutUser();
      }
    });

    return unsubscribe;
  }, [firebaseRepo]);

  return (
    <FirebaseState.Provider value={{ firebaseConfig }}>
      {children}
    </FirebaseState.Provider>
  );
};

MyFirebaseProvider.propTypes = {
  children: PropTypes.node.isRequired,
  firebaseConfig: PropTypes.shape({
    apiKey: PropTypes.string.isRequired,
    authDomain: PropTypes.string.isRequired,
    databaseURL: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    storageBucket: PropTypes.string.isRequired,
    messagingSenderId: PropTypes.string.isRequired,
    appId: PropTypes.string.isRequired,
    firebaseOptions: PropTypes.objectOf(PropTypes.any),
  }).isRequired,
};

export default MyFirebaseProvider;
